import basket from './basket';

export default {
  namespaced: true,
  modules: {
    basket
  },
};
